import { REQUIRED_COLUMNS } from './parseCsvRows'

export interface ValidationResult {
    valid: boolean
    missingColumns: string[]
    error: string | null
}

export const validateCsvHeaders = (fields: string[] | undefined | null): ValidationResult => {
    if (!fields || fields.length === 0) {
        return {
            valid: false,
            missingColumns: REQUIRED_COLUMNS.slice(),
            error: 'הקובץ לא מכיל כותרות'
        }
    }

    const trimmed = fields.map(f => (f == null ? '' : String(f).trim()))
    const missingColumns: string[] = []

    for (const column of REQUIRED_COLUMNS) {
        if (trimmed.indexOf(column) === -1) {
            missingColumns.push(column)
        }
    }

    if (missingColumns.length > 0) {
        return {
            valid: false,
            missingColumns: missingColumns,
            error: 'חסרות עמודות בקובץ: ' + missingColumns.join(', ')
        }
    }

    return { valid: true, missingColumns: [], error: null }
}
